function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessRulesModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "business_rules_modern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "M11.09 19a.874.874 0 0 1-.641-.256.869.869 0 0 1-.192-.956.888.888 0 0 1 .2-.3l4.163-4.111-.653-.644-4.137 4.111a.935.935 0 0 1-.292.2.857.857 0 0 1-.337.067.874.874 0 0 1-.641-.256.852.852 0 0 1-.259-.633.871.871 0 0 1 .068-.367.882.882 0 0 1 .18-.255l4.162-4.111-.63-.622-4.164 4.089a.935.935 0 0 1-.293.2.916.916 0 0 1-.36.067.869.869 0 0 1-.63-.267.848.848 0 0 1-.27-.622.828.828 0 0 1 .068-.334.923.923 0 0 1 .2-.289L10.8 9.6l-.653-.622L6 13.089a.852.852 0 0 1-.27.178.98.98 0 0 1-.383.067.874.874 0 0 1-.641-.256.852.852 0 0 1-.259-.633.828.828 0 0 1 .067-.333.923.923 0 0 1 .2-.289L9.74 6.867l3.375 3.356a1.864 1.864 0 0 0 .585.388 1.7 1.7 0 0 0 .675.145 1.8 1.8 0 0 0 1.26-.5 1.663 1.663 0 0 0 .54-1.277 2.011 2.011 0 0 0-.112-.644 1.593 1.593 0 0 0-.405-.622l-4.028-3.98a2.749 2.749 0 0 1 .855-.545A2.534 2.534 0 0 1 13.43 3a3.011 3.011 0 0 1 1.08.188 2.593 2.593 0 0 1 .9.589l3.8 3.778a2.556 2.556 0 0 1 .6.889A3.1 3.1 0 0 1 20 9.578a2.2 2.2 0 0 1-.2.9 2.721 2.721 0 0 1-.585.834l-7.495 7.421a.887.887 0 0 1-.315.222 1.009 1.009 0 0 1-.315.045zm-7.717-7.111-.585-.578a2.385 2.385 0 0 1-.585-.844A2.645 2.645 0 0 1 2 9.444a2.52 2.52 0 0 1 .225-1.067 2.766 2.766 0 0 1 .563-.822l3.8-3.778a2.728 2.728 0 0 1 .855-.567A2.461 2.461 0 0 1 8.412 3a3.23 3.23 0 0 1 1.08.167 2.525 2.525 0 0 1 .922.611l4.613 4.556a.923.923 0 0 1 .2.289.828.828 0 0 1 .068.333.848.848 0 0 1-.27.622.869.869 0 0 1-.63.267.885.885 0 0 1-.338-.056.948.948 0 0 1-.292-.211L9.718 5.622z",
    transform: "translate(1 1)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessRulesModern);
export default __webpack_public_path__ + "static/media/business_rules_modern.0531a345acea2c282555d7f1614db2af.svg";
export { ForwardRef as ReactComponent };